import styled, { css } from 'styled-components';

import { breakpoints, theme } from '@notino/react-styleguide';

export const Wrapper = styled.div`
  width: 100%;

  @media (min-width: ${breakpoints.md}) {
    width: 66%;
  }
  @media (min-width: 1680px) {
    width: 60%;
  }
`;

export const SectionTitle = styled.p<{ newDesign: boolean }>`
  padding-top: 1.3rem;

  ${({ newDesign }) =>
    newDesign
      ? css`
          ${theme.typography.titleMedium}
          margin: 0 0 0.75rem;
        `
      : css`
          font-size: 0.9rem;
          line-height: 1.5;
          font-weight: 700;
          margin: 0;

          @media (min-width: ${breakpoints.md}) {
            font-size: 1.1rem;
          }
        `}
`;

export const Text = styled.div<{ newDesign: boolean }>`
  line-height: 1.5rem;
  margin: 0 0 0.3rem;
  font-size: 0.9rem;

  strong {
    font-size: 0.8rem;
  }

  ${({ newDesign }) =>
    newDesign &&
    css`
      color: ${theme.palette.neutralDarker};

      strong {
        font-size: inherit;
      }
    `}
`;

export const TableWrapper = styled.div<{ newPdDesignEnabled: boolean }>`
  ${({ newPdDesignEnabled }) =>
    newPdDesignEnabled
      ? css`
          display: flex;
          table {
            margin: 2rem 0 0;
            border-spacing: 0;
            border: solid 1px ${theme.palette.neutralLight};
            overflow: hidden;
            border-radius: 0.4rem;
            font-family: 'Roboto';
            flex: 1;
            max-width: 450px;
          }

          tr {
            display: flex;
            justify-content: flex-end;
            font-size: 0.9rem;

            &:first-of-type {
              font-weight: 500;
            }

            &:nth-child(odd) {
              background-color: ${theme.palette.neutralLighter};
            }
          }

          td {
            padding: 0.6rem 0.7rem;

            &:nth-child(1) {
              width: 100%;
              color: ${theme.palette.neutralDarker};
              @media (min-width: ${breakpoints.sm}) {
                min-width: 20rem;
              }
            }

            &:nth-child(2) {
              text-align: right;
              padding-right: 0;
              min-width: 5rem;
              overflow: hidden;
            }

            &:nth-child(3) {
              padding-left: 0.1rem;
            }
          }
        `
      : css`
          table {
            margin: 1rem 0 2rem;
            border-spacing: 0;
            width: 100%;
            max-width: 300px;
          }

          tr {
            display: flex;
            justify-content: flex-end;
            font-size: 0.7rem;

            &:first-of-type {
              font-size: 0.9rem;
              font-weight: bold;
            }

            &:nth-child(odd) {
              background-color: ${theme.palette.neutralLight};
            }
          }

          td {
            padding: 0.5rem;

            &:nth-child(1) {
              width: 100%;
            }

            &:nth-child(2) {
              text-align: right;
              padding-right: 0;
              min-width: 5rem;
              overflow: hidden;
            }

            &:nth-child(3) {
              padding-left: 0.1rem;
            }
          }
        `}
`;

export const VitaminsTableWrapper = styled(TableWrapper)``;
